var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInvisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible",
    clipPath: "url(#clip0_1867_12928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.87823 5.46598L10.1686 7.75637L10.1795 7.6364C10.1795 6.43303 9.20158 5.45508 7.99821 5.45508L7.87823 5.46598Z",
    fill: "#D93B0C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.99819 4.00086C10.005 4.00086 11.6337 5.6296 11.6337 7.63641C11.6337 8.1054 11.5392 8.55257 11.3756 8.96337L13.5024 11.0902C14.6003 10.174 15.4656 8.98883 16 7.63641C14.7385 4.44442 11.6374 2.18311 7.99822 2.18311C6.98026 2.18311 6.00596 2.36487 5.10071 2.69207L6.67126 4.25897C7.08203 4.09902 7.5292 4.00086 7.99819 4.00086Z",
    fill: "#D93B0C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.727096 2.01959L2.3849 3.6774L2.71575 4.00824C1.51602 4.94621 0.567144 6.19321 0 7.6365C1.25791 10.8285 4.36265 13.0898 7.99819 13.0898C9.12522 13.0898 10.2013 12.8717 11.1866 12.4754L11.4956 12.7844L13.6151 14.9076L14.5422 13.9841L1.65416 1.09253L0.727096 2.01959ZM4.74802 6.03687L5.8714 7.16025C5.83868 7.31659 5.81687 7.4729 5.81687 7.6365C5.81687 8.83987 6.79482 9.81782 7.99819 9.81782C8.16179 9.81782 8.31813 9.79601 8.47083 9.76329L9.59421 10.8867C9.11067 11.1266 8.57263 11.272 7.99819 11.272C5.99138 11.272 4.36265 9.64331 4.36265 7.6365C4.36265 7.06209 4.50808 6.52402 4.74802 6.03687Z",
    fill: "#D93B0C"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1867_12928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvisible);
export default __webpack_public_path__ + "static/media/icon_invisible.84376e718a9e5355d2fd6b07fa036c50.svg";
export { ForwardRef as ReactComponent };